import * as React from "react";

import {Button as DropdonButton, Dropdown, DropdownProps, Popup} from 'semantic-ui-react';
import {ITranslatedComponent} from "../../../../redux/reducers/generalReducer";
import {compose} from "redux";
import {translate} from "react-i18next";
import {LanguageDto} from "../../../../services/Client";
import {lang2flag} from "../../../MultiLineColumn";
import {VIEWNAME} from "../../../../utils/GeneralUtils";

interface IDropdownItem extends DropdownProps {
    content: string;
    icon: string;
    disabled: boolean;
    onClick: () => void;
}

interface IOwnProps {
    [key: string]: any;
}

interface IStandardModeHeader extends  ITranslatedComponent, IOwnProps {

}

class StandardModeHeader extends React.Component<IStandardModeHeader> {
    constructor(props: IStandardModeHeader) {
        super(props);
    }

    render() {
        const {
            isSelected,
            viewName,
            hasAsisigmantsAction,
            hasCopyYearButton,
            hasHistoryButton,
            hasNewButton = false,
            hasCopyButton = false,
            hasDeleteButton = false,
            hasMultipleDeleteButton = false,
            hasEditButton = false,
            hasReloadButton = false,
            hasExportButton = false,
            hasExcelExportButtonV2 = false,
            hasSpecificOptionButton = false,
            hasCompareButton = false,
            hasTransferAssignmentsButton = false,
            hasWorkflowStatusMultiUpdateButton = false,
            hasCheckPCCDSyncronisationButton = false,
            hasUpdateDraftAssignmentsButton = false,
            hasSelectLanguageButton = false,

            disabledNewButton = false,
            disabledCopyButton = false,
            disabledDeleteButton = false,
            disabledMultipleDeleteButton = false,
            disabledEditButton = false,
            disabledReloadButton = false,
            disabledExportButton = false,
            disabledExcelExportButtonV2 = false,
            disabledSpecificOptionButton = false,
            disabledCompareButton = false,
            disableTransferAssignmentsButton = true,
            disableWorkflowStatusMultiUpdateButton = true,
            disableCheckPCCDSyncronisationButton = true,
            disableUpdateDraftAssignmentsButton = true,
            disabledSelectLanguageButton = false,
            labelHistoryButton,
            labelNewButton = "",
            labelCopyButton = "",
            labelDeleteButton = "",
            labelMultipleDeleteButton = "",
            labelEditButton = "",
            labelReloadButton = "",
            labelExportButton = "",
            labelExcelExportButtonV2 = "",
            labelSpecificOptionButton = "",
            labelCompareButton = "",
            labelTransferAssignmentsButton = "",
            labelWorkflowStatusMultiUpdateButton = "",
            labelCheckPCCDSyncronisationButton = "",
            labelUpdateDraftAssignmentsButton = "",
            labelCopyYearButton,
            labelSelectLanguageButton = "",
            onClickHistoryButton,
            disableHistoryButton,
            onClickNewButton,
            onClickCopyButton,
            onClickDeleteButton,
            onClickMultipleDeleteButton,
            onClickEditButton,
            onClickReloadButton,
            onClickExportButton,
            onClickExcelExportButtonV2,
            onClickSpecificOptionButton,
            onClickCompareButton,
            onClickTransferAssignmentsButton,
            onClickWorkflowStatusMultiUpdateButton,
            onClickCheckPCCDSyncronisationButton,
            onClickUpdateDraftAssignmentsButton,
            onClickCopyYearButton,
            onClickSelectLanguageButton,
            deleteButtonExchangeLabel,
            onClickInitPslButton,
            labelPslButton,
            hasInitPslButton,
            selectedLanguages,
            languageList,
            labelFlagMultiUpdateButton,
            onClickFlagMultiUpdate

        } = this.props;

        const btnInitPsl = !hasInitPslButton
            ? undefined
            : {
                content: labelPslButton,
                icon: "car",
                disabled: false,
                onClick: onClickInitPslButton,
            };

        const btnNew = !hasNewButton || disabledNewButton
            ? undefined
            : {
                content: labelNewButton,
                icon: "add",
                disabled: disabledNewButton,
                onClick: onClickNewButton,
                id: 'add-button'
            };

        const btnCopy = !hasCopyButton || disabledCopyButton
            ? undefined
            : {
                content: labelCopyButton,
                icon: "copy",
                disabled: disabledCopyButton,
                onClick: onClickCopyButton,
                id: 'copy-button'
            };

        const btnHistory = !hasHistoryButton || disableHistoryButton
            ? undefined
            : {
                content: labelHistoryButton,
                icon: "history",
                disabled: disableHistoryButton,
                onClick: onClickHistoryButton,
                id: 'history-button'
            };

        const btnDelete = !hasDeleteButton || disabledDeleteButton
            ? undefined
            : {
                content: deleteButtonExchangeLabel ? deleteButtonExchangeLabel : labelDeleteButton,
                icon: "delete",
                disabled: disabledDeleteButton,
                onClick: onClickDeleteButton,
                id: 'delete-button'
            };

        const btnMultipleDelete = !hasMultipleDeleteButton || disabledMultipleDeleteButton
            ? undefined
            : {
                content: labelMultipleDeleteButton,
                icon: "delete",
                disabled: disabledMultipleDeleteButton,
                onClick: onClickMultipleDeleteButton,
                id: 'delete-multiple-button'

            };

        const btnEdit = !hasEditButton || disabledEditButton
            ? undefined
            : (
                <DropdonButton
                    content={labelEditButton}
                    icon="edit"
                    disabled={disabledEditButton}
                    onClick={onClickEditButton}
                    id='edit-button'
                    className='table-header-button'
                />
            );

        const btnReload = !hasReloadButton || disabledReloadButton
            ? undefined
            : (
                <Popup
                    trigger={
                        <DropdonButton
                            icon="refresh"
                            onClick={onClickReloadButton}
                            className='table-header-button'
                        />
                    }
                    content={labelReloadButton}
                    inverted={true}
                    position='bottom center'
                />
            );

        const btnSpecificOption = !hasSpecificOptionButton || disabledSpecificOptionButton
            ? undefined
            : {
                content: labelSpecificOptionButton,
                icon: "file",
                disabled: disabledSpecificOptionButton,
                onClick: onClickSpecificOptionButton
            };

        const btnExport = !hasExportButton
            ? undefined
            : {
                content: labelExportButton,
                icon: 'file alternate',
                disabled: disabledExportButton,
                onClick: onClickExportButton
            };

        const btnExcelExportV2 = !hasExcelExportButtonV2
            ? undefined
            : {
                content: labelExcelExportButtonV2,
                icon: "wordpress forms",
                disabled: disabledExcelExportButtonV2,
                onClick: onClickExcelExportButtonV2
            };

        const btnCompare = !hasCompareButton || disabledCompareButton
            ? undefined
            : {
                content: labelCompareButton,
                icon: "exchange",
                disabled: disabledCompareButton,
                onClick: onClickCompareButton
            };

        const btnTransferAsgn = !hasTransferAssignmentsButton || disableTransferAssignmentsButton
            ? undefined
            : {
                content: labelTransferAssignmentsButton,
                icon: "exchange",
                disabled: disableTransferAssignmentsButton,
                onClick: onClickTransferAssignmentsButton
            };

        const btnWorkflowStatusMultiUpdate = !hasWorkflowStatusMultiUpdateButton || disableWorkflowStatusMultiUpdateButton
            ? undefined
            : {
                content: labelWorkflowStatusMultiUpdateButton,
                icon: "fast backward step forward",
                disabled: disableWorkflowStatusMultiUpdateButton,
                onClick: onClickWorkflowStatusMultiUpdateButton,
            };
        const btnFlagMultiUpdate = !hasWorkflowStatusMultiUpdateButton || disableWorkflowStatusMultiUpdateButton
            ? undefined
            : {
                content: labelFlagMultiUpdateButton,
                icon: "flag",
                disabled: disableWorkflowStatusMultiUpdateButton,
                onClick: onClickFlagMultiUpdate,
            };
        const btnCheckPCCDSyncronisation = !hasCheckPCCDSyncronisationButton || disableCheckPCCDSyncronisationButton
            ? undefined
            : {
                content: labelCheckPCCDSyncronisationButton,
                icon: "random",
                disabled: disableCheckPCCDSyncronisationButton,
                onClick: onClickCheckPCCDSyncronisationButton
            };

        const btnUpdateDraftAssignments = !hasUpdateDraftAssignmentsButton || disableUpdateDraftAssignmentsButton
            ? undefined
            : {
                content: labelUpdateDraftAssignmentsButton,
                icon: "angle double up",
                disabled: disableUpdateDraftAssignmentsButton,
                onClick: onClickUpdateDraftAssignmentsButton
            };
        let crudButtons;
        if(viewName !== VIEWNAME.OPTIONVIEW) {
             crudButtons = [
                btnInitPsl,
                btnNew,
                btnCopy,
                btnDelete,
                btnMultipleDelete,
                btnHistory,
            ].filter((item: IDropdownItem) => !!item);
         } else {
            crudButtons = [
                btnInitPsl,
                btnNew,
                btnCopy,
                btnMultipleDelete,
                btnHistory,
            ].filter((item: IDropdownItem) => !!item);
         }

        const crudActions = isSelected && crudButtons.length > 0 && (
            <Dropdown
                style={{width: "173px", margin: "auto 5px", height: '40px', marginTop: '5px', marginRight: '10px', padding: '13px'}}
                fluid={true}
                text={this.props.t("GLOBAL:CRUD_ACTIONS")}
                labeled={true}
                button={true}
                data-cy='crud-actions-button'
                className='icon table-header-button'
            >
                <Dropdown.Menu>
                    {crudButtons.map((item: IDropdownItem, index: number) =>
                        <Dropdown.Item
                            key={index}
                            content={item.content}
                            icon={item.icon}
                            disabled={item.disabled}
                            onClick={item.onClick}
                            id={item.id}
                        />
                    )}
                </Dropdown.Menu>
            </Dropdown >
        );

        const assignmentButtons = [
            btnSpecificOption,
            btnExport,
            btnExcelExportV2,
            btnCompare,
            btnTransferAsgn,
            btnUpdateDraftAssignments,
            btnWorkflowStatusMultiUpdate,
            btnCheckPCCDSyncronisation,
            btnFlagMultiUpdate
        ].filter((item: IDropdownItem) => !!item);

        const asisigmantsAction = hasAsisigmantsAction === undefined || assignmentButtons.length === 0
            ? undefined
            : (
            <Dropdown
                style={{width: "210px", margin: "auto 5px", height: '40px', marginTop: '5px', marginRight: '10px', padding: '13px'}}
                fluid={true}
                text={this.props.t("GLOBAL:ASSIGNMENT_OPTIONS")}
                labeled={true}
                button={true}
                className='icon table-header-button'
                loading={disabledExportButton || disabledExcelExportButtonV2}
                disabled={disabledExportButton || disabledExcelExportButtonV2}
            >
                <Dropdown.Menu>
                    {assignmentButtons.map((item: IDropdownItem, index: number) =>
                        item && <Dropdown.Item
                            key={index}
                            content={item.content}
                            icon={item.icon}
                            disabled={item.disabled}
                            onClick={item.onClick}
                        />
                    )}
                </Dropdown.Menu>
            </Dropdown >
        );

        const btnSelectLanguage = !hasSelectLanguageButton || disabledSelectLanguageButton
            ? undefined
            : (
                <Dropdown
                    style={{width: "210px", margin: "auto 5px", height: '40px', marginTop: '5px', marginRight: '10px', padding: '13px'}}
                    fluid={true}
                    text={this.props.t(labelSelectLanguageButton)}
                    labeled={true}
                    button={true}
                    className='icon table-header-button'
                    loading={disabledSelectLanguageButton}
                    disabled={disabledSelectLanguageButton}
                    scrolling={true}
                >
                    <Dropdown.Menu>
                        {languageList && languageList.map((item: LanguageDto, index: number) => {
                            let checked: boolean = false;
                            selectedLanguages.forEach((val: LanguageDto) => {
                                if (val.vmce === item.vmce) {
                                    checked = true;
                                }
                            });
                            return (
                                item && <Dropdown.Item
                                    key={index}
                                    text={item.nameDe}
                                    flag={lang2flag(item.vmce)}
                                    icon={checked ? "check" : ""}
                                    disabled={(selectedLanguages.length >= 2 && !checked) ? true : false}
                                    onClick={(event, data) => onClickSelectLanguageButton(index)}
                                />
                            );
                        })}
                    </Dropdown.Menu>
                </Dropdown >
            );
        return (
            <div style={{display: 'flex'}}>
                {btnEdit}
                {crudActions}
                {asisigmantsAction}
                {btnSelectLanguage}
                {btnReload}
            </div>
        );
    }
}

export default compose<React.ComponentType<IOwnProps>>(
    translate("GLOBAL"),
)(StandardModeHeader);



// WEBPACK FOOTER //
// ./src/components/Table/components/headerComponents/StandardModeHeader.tsx